import {takeEvery} from 'redux-saga/effects'
import {
  DELETE_EXAM_SCHEDULE_SETTING,
  DELETE_MANY_EXAM_SCHEDULE_SETTINGS,
  GENERATE_CLASS_SCHEDULE,
  GENERATE_INDIVIDUAL_SCHEDULE,
  GET_EXAM_SCHEDULE_SETTING,
  SAVE_EXAM_SCHEDULE_SETTING,
} from 'setup/redux/Actions/ExamScheduleSetting/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* examScheduleSettingSaga() {
  yield takeEvery(GET_EXAM_SCHEDULE_SETTING, fetchData)
  yield takeEvery(SAVE_EXAM_SCHEDULE_SETTING, fetchData)
  yield takeEvery(DELETE_EXAM_SCHEDULE_SETTING, fetchData)
  yield takeEvery(DELETE_MANY_EXAM_SCHEDULE_SETTINGS, fetchData)
  yield takeEvery(GENERATE_INDIVIDUAL_SCHEDULE, fetchData)
  yield takeEvery(GENERATE_CLASS_SCHEDULE, fetchData)
}

export default examScheduleSettingSaga
